import { useMutation, useQuery, useQueryClient } from 'react-query';
import { toastError, toastSuccess } from 'partial/components/react-geek-toast';
import { getQR, mfaSetup } from './actions';

export const useQR = () => {
  const { data, isLoading } = useQuery({
    queryKey: ['get-qr'],
    queryFn: getQR,
    retry: false,
    keepPreviousData: true,
  });
  return [isLoading, data];
};

export const useMfaSetup = (callBack = () => {}) => {
  const qc = useQueryClient();
  const { mutate, isLoading } = useMutation(mfaSetup, {
    onSuccess: (res) => {
      qc.invalidateQueries('my-profile');
      toastSuccess(res.data?.message);
      callBack();
    },
    onError: (res) => {
      toastError(res?.response?.data?.message);
    },
  });
  return [isLoading, mutate];
};
